class NavTokenMapService {
    static getNavToken(navTokenId) {
        var navTokenList = reactConfigObject.navTokens;
        
        if (navTokenList && navTokenList.length > 0) {
            var index = navTokenList
                .map(navTokenEntry => {
                    return navTokenEntry.tokenName;
                }).indexOf(navTokenId);

            return navTokenList[index];
        }
    }

    static navigateToToken(navTokenId) {
        window.location.href = this.getNavToken(navTokenId).url;
        return false;
    }
}

export default NavTokenMapService;